import { render, staticRenderFns } from "./HomeEcosystems.vue?vue&type=template&id=bd0c9a1a&scoped=true&"
import script from "./HomeEcosystems.vue?vue&type=script&lang=js&"
export * from "./HomeEcosystems.vue?vue&type=script&lang=js&"
import style0 from "./HomeEcosystems.vue?vue&type=style&index=0&id=bd0c9a1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0c9a1a",
  null
  
)

export default component.exports